import { ConstructionApprovalList } from '@/types/api/mypage/constructionAgreementInfo';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/** 工事承諾内容確認画面で扱う工事前後の情報。 */
export type ConstructionAgreementInfoStateType = {
  construction_approval_list: ConstructionApprovalList[];
};

/**
 * 工事承諾内容取得APIの結果を保持する state。
 * 工事前後の承諾項目を同一画面内で比較表示するため、取得した一覧をそのまま保持する。
 */
export const ConstructionAgreementInfoState = atom<ConstructionAgreementInfoStateType>({
  key: 'ConstructionAgreementInfoState',
  default: {
    construction_approval_list: [],
  },
  effects_UNSTABLE: [persistAtom],
});

export default ConstructionAgreementInfoState;
